<template>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="provinces"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          dataKey="cle"
          :paginator="true"
          :rows="10"
          sort-field="pays"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} provinces"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="clePays"
            header="Clé Pays"
            :sortable="true"
        ></Column>
        <Column
                field="pays"
                header="Pays"
                :sortable="true"
        ></Column>
        <Column
            field="cle"
            header="Clé Province"
            :sortable="true"
        ></Column>
        <Column field="description" header="Province" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../../Commun/DialogConfirmation.vue';

export default {
  props: ['provinces', 'isRechercheDataLoading'],
  emits: ['removeProvinceFromList'],
  components: {
    DialogConfirmation
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  methods: {
    confirmerSuppression(lien) {
        this.provinceASupprimer = lien;
        this.$confirm.require({
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            message: "Voulez-vous supprimer cette province?",
            accept: this.provinceSupprimer,
            reject: () => {
            },
        })
    },
    provinceSupprimer() {
        this.$store.dispatch('pilotage/supprimerTableValeurAction', {
            tableValeur: this.provinceASupprimer
        }).then((res) => {
        if(res.data.length > 0){
          this.$root.$refs.messagesComp.messagesList = res.data
        }else{
          this.$toast.add({
            severity:'success',
            summary: 'Suppression Province',
            detail:"La suppression a été effectuée",
            life: 6000
          });
          this.$emit("removeProvinceFromList", this.provinceASupprimer);
        }
      });
    },
    sauvegarder(data) {
      let tableValeur = {};
      let libelle = {};
      libelle.valeur = data.cle;
      libelle.texte = data.description;
      tableValeur.libelleVO = libelle;
      
      this.$store.dispatch('pilotage/modifierTableValeurAction', {tableValeur: tableValeur}).then(() => {
        this.$toast.add({
          severity:'success',
          summary: 'Modification Province',
          detail:'La modification a été effectuée',
          life: 6000
        });
      });
    },
  }
    
}
</script>
